//This controls our http requests, it will auto-inject the bearer token in all calls and will throw the user to /login if any are unauthorised

import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { getToken, logout } from './AuthService';

export function Initialise() {
  // let request = axiosRequestInterceptor;
  // let response = axiosResponseInterceptor;
  axios.defaults.baseURL = "https://" + window.location.hostname + ":5001/";

  axios.defaults.paramsSerializer = function (params) {
    return qs.stringify(params, { indices: false }); // param=value1&param=value2
  }

  axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`;
}

//Interceptors

// Add a request interceptor to add the bearer token header
axios.interceptors.request.use(function (config: any) {
  config.headers.Authorization = "bearer " + getToken();

  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor to check if unauthorised then send to login page instead
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response && error.response.status === 401) {
    logout();
    let destination = window.location.href.replace(window.location.origin, "");
    window.location.href = "/Login?redirect=" + destination;
  }

  return Promise.reject(error);
});